<template>
<v-container fluid>
 <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
<v-layout class="mt-12">
<v-flex xs12>
  <div :class="paginatedItems.length === 5 ? 'approvesettlements_box' : 'approvesettlements_box_empty'">
    <v-card-title>
      <v-flex xs5>
        <h5 class="accent--text" style="font-size: 12px; font-weight:700">Loan Requests </h5>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs1>
      <v-btn small color="secondary" @click="getReport"> Export </v-btn>
      </v-flex>
    </v-card-title>
    <v-card-text>
    <table class="table">
      <thead class="thead">
        <tr>
          <th scope="col">National ID</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisation Name</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in paginatedItems" v-bind:key="item.id">
          <td> {{ item.farmer.farmerId }} </td>
          <td>{{ item.farmer.firstName }}</td>
          <td>{{ item.farmer.lastName }}</td>
          <td>{{ item.farmer.mobileNumber }}</td>
          <td>{{ item.grower.organisationName }}</td>
          <td>{{ item.dateCreated  }}</td>
          <td>{{ item.amount }}</td>
          <td>{{ item.disburseStatus.description }}</td>
          <td class="actions">
            <v-list-item v-if="canBeAuthorized(item)">
            <v-btn @click="getLoanRequestDetails1(item,'approve')" small color="primary"> Approve </v-btn>
            </v-list-item>
            <v-list-item v-if="canBeApproved(item)">
            <v-btn @click="getLoanRequestDetails1(item,'approve')" small> Approve </v-btn>
            </v-list-item>
            <v-list-item v-if="canBeAuthorized(item)">
            <v-btn @click="getLoanRequestDetails1(item,'reject')" small> Reject </v-btn>
            </v-list-item>
            <v-list-item v-if="canBeApproved(item)">
            <v-btn @click="getLoanRequestDetails1(item,'reject')" small> Reject </v-btn>
            </v-list-item>
          </td>
        </tr>
      </tbody>
    </table>
    </v-card-text>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
      v-model="page"
      :length="numberOfLinks"
      :total-visible="7"
      color="secondary"
                class="accent--text logoutbtn"
    ></v-pagination>
    </v-card-actions>
  </div>
</v-flex>
<v-dialog v-model="approveDialog" max-width="900" persistent>
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Approve Loan Request
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
          <th scope="col">National Id</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisaction Name</th>
          <th scope="col">Organisaction Code</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in loan" v-bind:key="item.memberNumber">
          <td> {{ item.farmer.farmerId }} </td>
          <td>{{ item.farmer.firstName }}</td>
          <td>{{ item.farmer.lastName }}</td>
          <td>{{ item.farmer.mobileNumber }}</td>
          <td>{{ item.grower.organisationName }}</td>
          <td>{{ item.grower.organisationCode }}</td>
          <td>{{ item.dateCreated }}</td>
          <td>{{ item.amount }}</td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeApproveDialog"> Close </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="secondary" round @click="authorizeApproveLoanRequest"> Approve </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="declineDialog" max-width="900" persistent>
  <v-form ref="rejectform">
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Decline Loan Request
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
          <th scope="col">National Id</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisaction Name</th>
          <th scope="col">Organisaction Code</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in loan" v-bind:key="item.memberNumber">
          <td>{{ item.farmer.farmerId }} </td>
          <td>{{ item.farmer.firstName }}</td>
          <td>{{ item.farmer.lastName }}</td>
          <td>{{ item.farmer.mobileNumber }}</td>
          <td>{{ item.grower.organisationName }}</td>
          <td>{{ item.grower.organisationCode }}</td>
          <td>{{ item.dateCreated | prettyDate }}</td>
          <td>{{ item.amount }}</td>
          </tr>
          <tr>
            <td colspan="8">
              <v-text-field
                name="Reason"
                label="Reason"
                v-model.trim="loanRequest.approvalComment"
                :rules="reasonRules"
                required>
              </v-text-field>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeDeclineDialog"> Close </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="secondary" round @click="rejectDeclineLoanRequest"> Decline </v-btn>
    </v-card-actions>
  </v-card>
</v-form>
</v-dialog>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
export default {
	name: 'approvesettlements',
	data: function () {
		return {
			loanRequest: {
				approvalComment: ''
			},
			message: '',
			snackbar: false,
			snackbarColor: '',
			loading: false,
			search: '',
			permissions: [],
			results: [],
			totalResults: 0,
			paginatedItems: [],
			paginatedSettlements: [],
			numberOfLinks: 0,
			sNumberOfLinks: 0,
			numberOfItemsPerPage: 10,
			page: 1,
			sPage: 1,
			approveDialog: false,
			settlementdetails: [],
			payment: {},
			loan: [],
			declineDialog: false,
			organisationId: '',
			reasonRules: [
				v => !!v || 'Reason is required'
			]
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.loadData()
		this.permissions = store.state.user.roleId.permissions
		// eslint-disable-next-line
    // this.results = [{'id': 1, 'transactionId': 'IB116bd6f6b7f45NKH', 'narration': '', 'amount': '10000', 'transactionDate': '2019-07-09T16:40:21.578+03:00', 'currency': 'KES', 'xRate': 1 }]
	},
	watch: {
		results: function () {
			this.numberOfLinks = Math.ceil(this.results.length / this.numberOfItemsPerPage)
			this.paginatedItems = this.paginationMethod(this.results, 1, this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.paginationMethod(this.results, val, this.numberOfItemsPerPage)
		},
		settlementdetails: function () {
			this.sNumberOfLinks = Math.ceil(this.settlementdetails.length / this.numberOfItemsPerPage)
			this.paginatedSettlements = this.paginationMethod(this.settlementdetails, 1, this.numberOfItemsPerPage)
		},
		sPage: function (val) {
			this.paginatedSettlements = this.paginationMethod(this.settlementdetails, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		closeApproveDialog () {
			this.approveDialog = false
			this.settlementdetails = []
		},
		closeDeclineDialog () {
			this.declineDialog = false
			this.settlementdetails = []
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		loadData () {
			const url = config.serverURI + '/disbursement/pending/' + this.organisationId
			axios.get(url)
				.then(response => {
					this.results = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.results
		},
		getLoanRequestDetails1 (item, requestType) {
			this.loan = [item]
			if (requestType === 'approve') {
				this.approveDialog = true
			} else {
				this.declineDialog = true
			}
		},
		getLoanRequestDetails (item, requestType) {
			const url = config.serverURI + '/settlement/transactions'
			axios.post(url, item)
				.then(response => {
					this.settlementdetails = response.data
					this.payment = item
					if (requestType === 'approve') {
						this.approveDialog = true
					} else {
						this.declineDialog = true
					}
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		canBeApproved (item) {
			return item.disburseStatus.statusName === 'PENDING-APPROVAL' && this.hasPerm('CAN_APPROVE_LOAN_REQUEST')
		},
		canBeAuthorized (item) {
			return item.disburseStatus.statusName !== 'PENDING-APPROVAL' && item.disburseStatus.statusName === 'APPROVED' && this.hasPerm('CAN_AUTHORIZE_LOAN_REQUEST')
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		authorizeApproveLoanRequest () {
			const item = this.loan[0]
			if (this.canBeAuthorized(item)) {
				this.authorizeLoanRequest()
			}
			if (this.canBeApproved(item)) {
				this.approveLoanRequest()
			}
		},
		rejectDeclineLoanRequest () {
			this.message = ''
			this.error = ''
			const item = this.loan[0]
			if (this.$refs.rejectform.validate()) {
				item.approvalComment = this.loanRequest.approvalComment
				if (this.canBeAuthorized(item)) {
					this.declineLoanRequest()
				}
				if (this.canBeApproved(item)) {
					this.rejectLoanRequest()
				}
			}
		},
		approveLoanRequest () {
			const url = config.serverURI + '/disbursement/approve'
			axios.post(url, this.loan)
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeApproveDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		authorizeLoanRequest () {
			const url = config.serverURI + '/disbursement/authorize'
			axios.post(url, this.loan)
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeApproveDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		declineLoanRequest () {
			const url = config.serverURI + '/disbursement/decline'
			axios.post(url, this.loan[0])
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeDeclineDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		rejectLoanRequest () {
			const url = config.serverURI + '/disbursement/reject'
			axios.post(url, this.loan[0])
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeDeclineDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getReport () {
			const url = config.serverURI + '/disbursement/download/pending/'+this.organisationId
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = 'loantransactions.csv'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		}
	}
}

</script>
<style scoped>
.mytable .v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
.approvesettlements_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box:after, .approvesettlements_box:before {
  right: 100%;
  top: 80%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.approvesettlements_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.approvesettlements_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.table  tbody  tr >  td.actions {
  font-size: 10px !important;
  color: #733D29 !important;
  text-align:center;
  vertical-align: middle;
  padding-top: 0px;
  height: 10px;
}

</style>
